import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-dcd85c7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "d-sm-flex align-items-center justify-content-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "SKU Banding Results", -1))
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "bandResults_UnitVolume" }, "Unit Volume", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "bandResults_VolumeInStock" }, "Volume In Stock", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "bandResults_DailyCubicVelocity" }, "Daily Cubic Velocity", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "bandResults_PicksPerDay" }, "Picks Per Day", -1))
const _hoisted_10 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "dropdown" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-secondary dropdown-toggle",
  type: "button",
  id: "exportMenu",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " ... ", -1))
const _hoisted_13 = {
  class: "dropdown-menu",
  "aria-labelledby": "exportMenu"
}
const _hoisted_14 = { class: "table-responsive" }
const _hoisted_15 = {
  class: "table table-bordered table-hover mt-3",
  ref: "skuTable"
}
const _hoisted_16 = { key: 4 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { key: 3 }
const _hoisted_21 = { key: 4 }
const _hoisted_22 = { key: 5 }
const _hoisted_23 = { key: 6 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "8",
  class: "text-center"
}, "No data available", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  class: "modal fade",
  id: "settingsModal",
  tabindex: "-1",
  "aria-labelledby": "settingsModalLabel",
  "aria-hidden": "true"
}
const _hoisted_28 = { class: "modal-dialog" }
const _hoisted_29 = { class: "modal-content" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "settingsModalLabel"
  }, "Column Settings"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_31 = { class: "modal-body" }
const _hoisted_32 = { class: "form-check" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "quantityOfSKUs"
}, "Quantity of SKUs", -1))
const _hoisted_34 = { class: "form-check" }
const _hoisted_35 = {
  class: "form-check-label",
  for: "meanVolume"
}
const _hoisted_36 = { class: "form-check" }
const _hoisted_37 = {
  class: "form-check-label",
  for: "medianVolume"
}
const _hoisted_38 = { class: "form-check" }
const _hoisted_39 = {
  class: "form-check-label",
  for: "totalVolume"
}
const _hoisted_40 = { class: "form-check" }
const _hoisted_41 = {
  class: "form-check-label",
  for: "percentageOfTotalVolume"
}
const _hoisted_42 = { class: "form-check" }
const _hoisted_43 = {
  class: "form-check-label",
  for: "maxVolume"
}
const _hoisted_44 = { class: "form-check" }
const _hoisted_45 = {
  class: "form-check-label",
  for: "minVolume"
}
const _hoisted_46 = { class: "modal-footer" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, "Close", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedBand) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateHeadersAndFetchData && _ctx.updateHeadersAndFetchData(...args))),
            class: "form-select me-3"
          }, _hoisted_10, 544), [
            [_vModelSelect, _ctx.selectedBand]
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("ul", _hoisted_13, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "#",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.exportTable('jpg')), ["prevent"]))
                }, "Export to JPG")
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "#",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.exportTable('png')), ["prevent"]))
                }, "Export to PNG")
              ])
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary ms-3",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleSettingsModal && _ctx.toggleSettingsModal(...args)))
          }, " Column Settings ")
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("table", _hoisted_15, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortTable('band')))
              }, "Band"),
              (_ctx.columnsVisibility.quantityOfSKUs)
                ? (_openBlock(), _createElementBlock("th", {
                    key: 0,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sortTable('quantityOfSKUs')))
                  }, "Quantity of SKUs"))
                : _createCommentVNode("", true),
              (_ctx.columnsVisibility.meanVolume)
                ? (_openBlock(), _createElementBlock("th", {
                    key: 1,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sortTable('meanVolume')))
                  }, _toDisplayString(_ctx.volumeType) + " (Mean)", 1))
                : _createCommentVNode("", true),
              (_ctx.columnsVisibility.medianVolume)
                ? (_openBlock(), _createElementBlock("th", {
                    key: 2,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sortTable('medianVolume')))
                  }, _toDisplayString(_ctx.volumeType) + " (Median)", 1))
                : _createCommentVNode("", true),
              (_ctx.columnsVisibility.totalVolume)
                ? (_openBlock(), _createElementBlock("th", {
                    key: 3,
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sortTable('totalVolume')))
                  }, _toDisplayString(_ctx.volumeType) + " (Total)", 1))
                : _createCommentVNode("", true),
              (_ctx.columnsVisibility.percentageOfTotalVolume)
                ? (_openBlock(), _createElementBlock("th", _hoisted_16, "Percentage of " + _toDisplayString(_ctx.volumeType), 1))
                : _createCommentVNode("", true),
              (_ctx.columnsVisibility.maxVolume)
                ? (_openBlock(), _createElementBlock("th", {
                    key: 5,
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sortTable('maxVolume')))
                  }, _toDisplayString(_ctx.volumeType) + " (Max)", 1))
                : _createCommentVNode("", true),
              (_ctx.columnsVisibility.minVolume)
                ? (_openBlock(), _createElementBlock("th", {
                    key: 6,
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sortTable('minVolume')))
                  }, _toDisplayString(_ctx.volumeType) + " (Min)", 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.band
              }, [
                _createElementVNode("td", null, _toDisplayString(item.band), 1),
                (_ctx.columnsVisibility.quantityOfSKUs)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_17, _toDisplayString(item.quantityOfSKUs), 1))
                  : _createCommentVNode("", true),
                (_ctx.columnsVisibility.meanVolume)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(item.meanVolume.toFixed(6)), 1))
                  : _createCommentVNode("", true),
                (_ctx.columnsVisibility.medianVolume)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString(item.medianVolume.toFixed(6)), 1))
                  : _createCommentVNode("", true),
                (_ctx.columnsVisibility.totalVolume)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_20, _toDisplayString(item.totalVolume ? item.totalVolume.toFixed(6) : '-'), 1))
                  : _createCommentVNode("", true),
                (_ctx.columnsVisibility.percentageOfTotalVolume)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(_ctx.calculatePercentage(item.totalVolume).toFixed(2)) + "%", 1))
                  : _createCommentVNode("", true),
                (_ctx.columnsVisibility.maxVolume)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString(item.maxVolume.toFixed(6)), 1))
                  : _createCommentVNode("", true),
                (_ctx.columnsVisibility.minVolume)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString(item.minVolume.toFixed(6)), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (_ctx.bandData.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_24, _hoisted_26))
              : _createCommentVNode("", true)
          ])
        ], 512)
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: "quantityOfSKUs",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.columnsVisibility.quantityOfSKUs) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.columnsVisibility.quantityOfSKUs]
              ]),
              _hoisted_33
            ]),
            _createElementVNode("div", _hoisted_34, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: "meanVolume",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.columnsVisibility.meanVolume) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.columnsVisibility.meanVolume]
              ]),
              _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.volumeType) + " (Mean)", 1)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: "medianVolume",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.columnsVisibility.medianVolume) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.columnsVisibility.medianVolume]
              ]),
              _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.volumeType) + " (Median)", 1)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: "totalVolume",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.columnsVisibility.totalVolume) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.columnsVisibility.totalVolume]
              ]),
              _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.volumeType) + " (Total)", 1)
            ]),
            _createElementVNode("div", _hoisted_40, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: "percentageOfTotalVolume",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.columnsVisibility.percentageOfTotalVolume) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.columnsVisibility.percentageOfTotalVolume]
              ]),
              _createElementVNode("label", _hoisted_41, "Percentage of " + _toDisplayString(_ctx.volumeType), 1)
            ]),
            _createElementVNode("div", _hoisted_42, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: "maxVolume",
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.columnsVisibility.maxVolume) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.columnsVisibility.maxVolume]
              ]),
              _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.volumeType) + " (Max)", 1)
            ]),
            _createElementVNode("div", _hoisted_44, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: "minVolume",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.columnsVisibility.minVolume) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.columnsVisibility.minVolume]
              ]),
              _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.volumeType) + " (Min)", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _hoisted_47,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.applyColumnSettings && _ctx.applyColumnSettings(...args)))
            }, "Apply")
          ])
        ])
      ])
    ])
  ]))
}